import { NgModule } from '@angular/core';
import { DonnaCoreBootstrapModule } from './core-bootstrap.module';
import { DonnaCoreRoutingModule } from './core-routing.module';
import { ChassisCoreModule } from '@kaiser-software/chassis-core';

@NgModule({
    imports: [
        ChassisCoreModule,
        DonnaCoreBootstrapModule,
        DonnaCoreRoutingModule,
    ],
    exports: [
        ChassisCoreModule,
        DonnaCoreBootstrapModule,
        DonnaCoreRoutingModule,
    ]
})
export class DonnaCoreModule {

    constructor() {
        console.log('Donna Core Module bootstrapped');
    }

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/core.module.ts